export default __webpack_public_path__ + "static/media/stablecoins-icon.bbf5d2f4.svg";